// extracted by mini-css-extract-plugin
module.exports = {"tabletMiddle":"(max-width: 768px)","controls":"controls-AVEVA","button":"button-12hTh","back":"back-3W_jy"};